"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionState = void 0;
var PositionState;
(function (PositionState) {
    PositionState[PositionState["UNLOCKED"] = 0] = "UNLOCKED";
    PositionState[PositionState["LOCKING"] = 1] = "LOCKING";
    PositionState[PositionState["LOCKED"] = 2] = "LOCKED";
    PositionState[PositionState["PREUNLOCKING"] = 3] = "PREUNLOCKING";
    PositionState[PositionState["UNLOCKING"] = 4] = "UNLOCKING";
})(PositionState || (exports.PositionState = PositionState = {}));
